import SecondaryButton from "../../../../components/buttons/SecondaryButton";

const ManagePlatformSecretButton = ({ handleOnClick }) => {
  return (
    <SecondaryButton onClick={handleOnClick}>
      Manage Platform Secret
    </SecondaryButton>
  );
};

export default ManagePlatformSecretButton;
